import * as React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import * as moment from 'moment';
import { CookiesProvider } from 'react-cookie';
import { ConfigProvider } from 'antd';

import fi_FI from 'antd/lib/locale-provider/fi_FI';
import AppContextProvider from 'components/context';
import Routes from './routes';
import config from './config';

import 'moment/locale/fi';
import 'utils/icons/fa-icons';
import CookieBanner from 'components/common/CookieBanner';

moment.locale('fi');

function App() {
    return (
        <CookiesProvider>
            <ConfigProvider locale={fi_FI}>
                <AppContextProvider>
                    <Router basename={config.baseName}>
                        <Route component={ScrollToTop} />
                        <Routes />
                    </Router>
                    <CookieBanner />
                </AppContextProvider>
            </ConfigProvider>
        </CookiesProvider>
    );
}

const ScrollToTop = () => {
    window.scrollTo(0, 0);
    return null;
};

export default App;
